<template>
  <div class="list-filter-wrapper border-radius">
      <input v-model.trim="searchTerm" :placeholder="placeholder" @input="handleSearchTermChange">
  </div>
</template>

<script>

/*

searchConfig.targetlistType = 'flat' -- treat the target list as a flat array
searchConfig.targetKeys = ['key1', 'key2', ...] -- search single depth object keys

*/
export default {
    name: 'list-filter',
    props: {
        placeholder: {
            type: String,
            default: function() {
                return 'Search'
            }
        },
        targetList: Array,
        searchConfig: Object,
    },
    data() {
        return {
            searchTerm: ''
        }
    },
    watch: {
        targetList(val) {
           this.$emit('results', Array.from(val));
        },
    },
    methods: {
        updateFilteredList() {
            if (this.searchTerm === '') {
                this.$emit('results', this.targetList);
            } else {
                let fl = this.targetList.filter((item) => {

                    if (this.searchConfig.targetlistType == 'flat') {
                        return item.toLowerCase().includes(this.searchTerm.toLowerCase());
                    }

                    let filterMatch = false;

                    this.searchConfig.targetKeys.forEach(element => {

                        if (!item.hasOwnProperty(element)) {
                            console.error('Error. Could not find element "' + element + '" in search target');
                        }

                        if (item[element].toLowerCase().includes(this.searchTerm.toLowerCase())) {
                            filterMatch = true;
                        }

                    });

                    return filterMatch
                });

                this.$emit('results', fl);
            }
        },
        handleSearchTermChange() {
            this.updateFilteredList();
        }
    }
}
</script>

<style lang="scss">

.list-filter-wrapper {
    max-width: 300px;

    input {
        font-family: "LatoWeb", sans-serif;
        z-index: 0;
        height: 38px;
        border-radius: 2px;
        border: solid 1px #dedede;
        font-size: 12px;
        color: #333;
        padding: 10px 15px;
        width: 300px;
    }

}

</style>